import { defaultContur, conturs } from '../translations';

export const getStoreLogo = () => {
  if (defaultContur === conturs.me) {
    return {
      href: '#',
      icon: 'logoMe',
    };
  }

  return {
    href: '#',
    icon: 'logoD',
  };
};
